import ApiConstants from '../constants/ApiConstants';
import { PRODUCTS_CAPS } from '../components/SequenceNumberFormat/Other';
import http from "../http";

export interface CustomNumberFormatAPIConfig {
  SearchTerm?: string;
  pageSize?: number;
  pageNo?: number;
}

const defaultConfig: CustomNumberFormatAPIConfig = {
  SearchTerm: '',
  pageSize: 10,
  pageNo: 1
};

class CustomNumberFormatService {
  static apiConfig: CustomNumberFormatAPIConfig;

  static createCustomNumberFormat(payload: any) {
    return http
      .post(`${`/v1/people/tenants/sequenceformat/save`}`, payload)
      .catch((err: any) => {
        console.error('Error creating Custom Number Format: ', err);
        return Promise.reject(err);
      });
  }

  static toggleIsDefault(payload: any) {
    return http
      .put(`${`v1/sequenceformat/toggleIsDefault`}`, payload)
      .catch((err: any) => {
        console.error('Error creating Custom Number Format: ', err);
        return Promise.reject(err);
      });
  }

  static deleteCustomFormatNumber(payload: any) {
    let data: any = payload;
    return http
      .delete(`${`v1/sequenceformat/delete`}`, { data })
      .catch((err: any) => {
        console.error('Error creating Custom Number Format: ', err);
        return Promise.reject(err);
      });
  }

  static changeCustomNumberFormat(payload: any) {
    return http
      .put(`${`v1/sequenceformat/toggleIsDefault`}`, payload)
      .catch((err: any) => {
        console.error('Error creating Custom Number Format: ', err);
        return Promise.reject(err);
      });
  }

  static getCustomNumberFormat(module: string) {
    console.log("api call");
    return http
      .get(`${`/v1/people/tenants/sequenceformat/fetchActive`}`)
      .catch((err: any) => {
        console.error('Error creating Custom Number Format: ', err);
        return Promise.reject(err);
      });
  }

  static checkNumberFormatExistance(
    format: string,
    module: string
  ): Promise<any> {
    return http
      .post(`${`v1/documentcode/doesExist`}`, {
        module: module,
        application: PRODUCTS_CAPS.PEOPLE,
        code: format
      })
      .catch((err: any) => {
        console.error('Error creating Custom Number Format: ', err);
        return Promise.reject(err);
      });
  }
}

export default CustomNumberFormatService;
